import { useCallback } from 'preact/hooks';

import { useCurrentAsset } from './CurrentAssetProvider';

export const useAssetIdCopy = () => {
  const { asset } = useCurrentAsset();

  const handleContextMenu = useCallback(async () => {
    if (asset && 'clipboard' in navigator) {
      await navigator.clipboard.writeText(String(asset.id));
    }
  }, [asset]);

  return { handleContextMenu };
};
